import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import Modal from '../ui_components/modal';
import { getCustomerDigitalRecord, printCustomerDigitalRecord, printSingleCustomerDigitalRecord, printRecord } from '../../store/actions/appointments/appointments_action';
import { Table, TableHead, TableBody, TableRow, TableCell, makeStyles, TablePagination, Grid } from '@material-ui/core';
import { format } from 'date-fns';
import { PrintButton } from '../ui_components/common_buttons';

const useStyles = makeStyles({
    table: {
        minWidth: 500
    },
    alignCenter: {
        textAlign: 'center'
    }
});

const DigitalRecordModal = ({ customerUuid, customerName, customerBirthYear, open, setOpen }) => {
    const { table } = useStyles();

    const [customerDigitalRecord, setCustomerDigitalRecord] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        customerUuid && (async () => {
            const appointmentDigitalRecord = await getCustomerDigitalRecord({ customerUuid, page, rowsPerPage });
            console.log(appointmentDigitalRecord)
            setCustomerDigitalRecord(appointmentDigitalRecord);
        })();
    }, [customerUuid, page, rowsPerPage]);

    const getPrintContent = () => printCustomerDigitalRecord(customerUuid);
    const getPrintContentRecord = (uuid) => printRecord(uuid);

    const getPrintSingleContent = (digitalRecordUuid) => printSingleCustomerDigitalRecord(digitalRecordUuid, customerUuid);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const DigitalRecordTable = useMemo(() => {
        if (customerDigitalRecord?.['hydra:totalItems'] === 0) {
            return <h2>Nema podataka</h2>
        }
        return (
            <>
                <Grid container item justify="center">
                    <PrintButton label="Štampa svih kartona" getPrintContent={getPrintContent} />
                </Grid>
                <Table aria-label="table" className={table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Datum</TableCell>
                            <TableCell>Usluga</TableCell>
                            <TableCell>Radnik</TableCell>
                            <TableCell>Dijagnoza</TableCell>
                            <TableCell>Opis</TableCell>
                            <TableCell colSpan={2}>Terapija</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {customerDigitalRecord?.['hydra:member']?.map(({ startDate, endDate, article, worker, digitalRecord }, indexAppointment) => {
                            // {subAreadName, description, digitalRecordTherapy, uuid}
                            if (digitalRecord.length > 0) {
                                return digitalRecord?.map(({subAreadName, description, digitalRecordTherapy, uuid}, index) => {
                                    return(
                                        <TableRow hover key={index}>
                                            <TableCell>
                                                {/* TODO check if appointments last multiple days */}
                                                {format(new Date(startDate), 'dd.MM.yyyy HH:mm')} - {format(new Date(endDate), 'HH:mm')}
                                            </TableCell>
                                            <TableCell>{article?.name}</TableCell>
                                            <TableCell>{worker && `${worker?.firstName} ${worker?.lastName}`}</TableCell>
                                            <TableCell>{subAreadName}</TableCell>
                                            <TableCell>
                                                <div dangerouslySetInnerHTML={{__html: description}}>
                                                </div>
                                            </TableCell>
                                            <TableCell>{digitalRecordTherapy?.map(therapy => `${therapy.therapy?.name} ${therapy.therapy?.dose ? `${(therapy.therapy?.dose)}` : ''}`).join(', ')}</TableCell>
                                            <TableCell align="right">
                                                <PrintButton label="Štampa Karton"
                                                             getPrintContent={() => getPrintSingleContent(uuid)}/>
                                                <PrintButton label="Štampa Izveštaj"
                                                             getPrintContent={() => getPrintContentRecord(uuid)}/>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }
                            else {
                                return(
                                    <TableRow hover key={indexAppointment}>
                                        <TableCell>
                                            {/* TODO check if appointments last multiple days */}
                                            {format(new Date(startDate), 'dd.MM.yyyy HH:mm')} - {format(new Date(endDate), 'HH:mm')}
                                        </TableCell>
                                        <TableCell>{article?.name}</TableCell>
                                        <TableCell>{worker && `${worker?.firstName} ${worker?.lastName}`}</TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell align="right"></TableCell>
                                    </TableRow>
                                )
                            }
                        })}
                    </TableBody>
                </Table>
                <TablePagination
                    backIconButtonText="Prethodna stranica"
                    nextIconButtonText="Sledeća stranica"
                    labelRowsPerPage="Broj redova po stranici"
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={customerDigitalRecord?.['hydra:totalItems'] || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
        )
    }, [customerDigitalRecord]);

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            title={`Digitalni karton - ${customerName} ${customerBirthYear}`}
            content={DigitalRecordTable}
        />
    );
}

DigitalRecordModal.propTypes = {
    customerUuid: PropTypes.string,
    customerName: PropTypes.string,
    customerBirthYear: PropTypes.string,
    open: PropTypes.bool,
    setOpen: PropTypes.func
}

export default DigitalRecordModal;
